import React from "react";
import "./NewToken.css";
function NewToken() {
  return (
    <div>
      <section className="physical-item n-token create-own-bg">
        <div className="physical-item-content">
          <div className="container">
            <div className="row ">
              <div className="col-1"></div>

              <div className="col-10">
                <h6>Shop Profle Image</h6>

                <p className="filetype">
                  File types supported : JPG, PNG, GIF, SVG, MP4, WEBM, WAV,
                  OGG, GLB, GLTF . Max size : 100MB
                </p>

                <div className="row mt-5">
                  <div className="col-md-4">
                    <img
                      src="../../assets/images/createyourown/chooseimg.png"
                      alt=""
                      className="img-fluid img-picker"
                    />
                  </div>

                  <div className="col-md-8">
                    {/* ------------ */}
                    <div className=" rigt-side-wrap d-flex justify-content-between flex-column h-100">
                      <div>
                        <h3 className="craete-tit">Shop Name :</h3>
                        <p className="my-2 t-cntrct">Token Contract</p>
                        <input
                          className="create-input-txt mt-2"
                          placeholder="Bee"
                          type="text"
                        />
                      </div>
                      <div className="col-sm-12  c-btn">
                        <button className="createitembtn me-3 mt-5">
                          Create
                        </button>
                      </div>
                    </div>
                    {/* ------------ */}
                  </div>
                </div>
              </div>

              <div className="col-1"></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default NewToken;
